/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GraphDataModel } from '../../models/graph-data-model';
import { GraphGrouping } from '../../models/graph-grouping';
import { TargetGraphType } from '../../models/target-graph-type';

export interface GetTargetGraph$Params {
  patientID?: number;
  targetIDs?: Array<number>;
  startTime?: string;
  endTime?: string;
  graphType?: TargetGraphType;
  graphGrouping?: GraphGrouping;
  staffID?: number;
  includeTrendLine?: boolean;
  mergeSimilarPrompts?: boolean;
}

export function GetTargetGraph(http: HttpClient, rootUrl: string, params?: GetTargetGraph$Params, context?: HttpContext): Observable<StrictHttpResponse<GraphDataModel>> {
  const rb = new RequestBuilder(rootUrl, GetTargetGraph.PATH, 'get');
  if (params) {
    rb.query('patientID', params.patientID, {});
    rb.query('targetIDs', params.targetIDs, {});
    rb.query('startTime', params.startTime, {});
    rb.query('endTime', params.endTime, {});
    rb.query('graphType', params.graphType, {});
    rb.query('graphGrouping', params.graphGrouping, {});
    rb.query('staffID', params.staffID, {});
    rb.query('includeTrendLine', params.includeTrendLine, {});
    rb.query('mergeSimilarPrompts', params.mergeSimilarPrompts, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GraphDataModel>;
    })
  );
}

GetTargetGraph.PATH = '/api/Graph/GetTargetGraph';
